export default "__VITE_ASSET__BZq3Vj7X__"